/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paymentdeclinederror2Inputs */

const en_paymentdeclinederror2 = /** @type {(inputs: Paymentdeclinederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was declined. Please check your card details or use another card.`)
};

const de_paymentdeclinederror2 = /** @type {(inputs: Paymentdeclinederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Zahlung wurde abgelehnt. Bitte prüfe deine Kartendaten oder nutze eine andere Karte.`)
};

/**
* | output |
* | --- |
* | "Your payment was declined. Please check your card details or use another card." |
*
* @param {Paymentdeclinederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const paymentdeclinederror2 = /** @type {((inputs?: Paymentdeclinederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paymentdeclinederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paymentdeclinederror2(inputs)
	return de_paymentdeclinederror2(inputs)
});
export { paymentdeclinederror2 as "paymentDeclinedError" }